import { SubdivisionWarrantyStatusEnum } from '@vatos-pas/common';

const WarrantyStatusChoices = [
  {
    id: SubdivisionWarrantyStatusEnum.PRODUCTION,
    name: SubdivisionWarrantyStatusEnum.PRODUCTION,
  },
  {
    id: SubdivisionWarrantyStatusEnum.WARRANTY,
    name: SubdivisionWarrantyStatusEnum.WARRANTY,
  },
];

export { WarrantyStatusChoices };
